import { createContext, useContext, type ReactNode } from 'react'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

import { isAdditive } from './helpers'

/** Sekmeli yığının içindeki parça kendi kartını çizmez; kart ve başlık sekmeden gelir. */
export const InTabs = createContext(false)

export function WidgetCard({
  title,
  busy,
  printMode,
  actions,
  children,
}: {
  title?: string
  busy?: boolean
  /** Baskı: çerçevesiz, sayfa sonunda bölünmez. */
  printMode?: boolean
  /** Başlığın sağındaki denetimler (ör. kırılım seçici); sekmede içeriğin üstünde. */
  actions?: ReactNode
  children: ReactNode
}) {
  if (useContext(InTabs))
    return (
      <div aria-busy={busy || undefined} className={cn('transition-opacity', busy && 'opacity-60')}>
        {actions && <div className="flex justify-end px-3 pt-3">{actions}</div>}
        {children}
      </div>
    )
  return (
    <Card
      aria-busy={busy || undefined}
      className={cn(
        'gap-0 py-0 transition-opacity',
        busy && 'opacity-60',
        printMode && 'rounded-none border-0 shadow-none ring-0',
      )}
    >
      {(title || actions) && (
        <CardHeader className="border-border flex flex-row items-center justify-between gap-3 border-b px-4 py-3">
          <CardTitle className="text-sm font-medium">{title}</CardTitle>
          {actions}
        </CardHeader>
      )}
      <CardContent className="p-0">{children}</CardContent>
    </Card>
  )
}

/** Çapraz filtre yayan hücre/etiket: klavyeyle erişilebilir düğme. */
export function SelectButton({
  onSelect,
  children,
}: {
  onSelect: (additive: boolean) => void
  children: ReactNode
}) {
  return (
    <button
      type="button"
      className="text-left hover:underline focus-visible:underline"
      onClick={(event) => onSelect(isAdditive(event))}
    >
      {children}
    </button>
  )
}
